
interface TabBarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const TabBar = ({ activeTab, setActiveTab }: TabBarProps) => {
  const tabs = [
    { id: 'inicio', label: 'Inicio', icon: 'ri-home-line' },
    { id: 'calendario', label: 'Calendario', icon: 'ri-calendar-line' },
    { id: 'equipos', label: 'Equipos', icon: 'ri-team-line' },
    { id: 'contacto', label: 'Contacto', icon: 'ri-phone-line' }
  ];

  return (
    <nav className="fixed bottom-0 w-full bg-black/80 backdrop-blur-md border-t border-white/10 z-50">
      <div className="grid grid-cols-4 h-16">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex flex-col items-center justify-center space-y-1 transition-all duration-300 ${
              activeTab === tab.id 
                ? 'text-pink-400 scale-110' 
                : 'text-white/60 hover:text-white/80'
            }`}
          >
            <i className={`${tab.icon} text-lg`}></i>
            <span className="text-xs font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default TabBar;
